<template>
  <b-form>
    <b-form-group
      label="Reclutado"
      label-for="name"
    >
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon
            icon="FilterIcon"
            class="text-muted"
          />
        </b-input-group-prepend>
        <v-select
          id="frmDetRec"
          v-model="tipoDocSel"
          label="abreviatura"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="dataDocumentos"
        />
        <b-form-input
          id="search-reclutado"
          v-model="searchNroDoc"
          placeholder="Ingrese nro de documento"
        />
        <b-button
          variant="info"
          @click="searchPostulant"
        >
          <feather-icon icon="SearchIcon" />
        </b-button>
      </b-input-group>
    </b-form-group>

    <div
      v-if="isBusy"
      class="text-center text-primary my-2"
    >
      <b-spinner
        variant="primary"
        class="align-middle"
      />
      <strong class="ml-1">Cargando...</strong>
    </div>

    <b-alert
      v-height-fade.appear
      variant="danger"
      :show="msjVal.length > 0 ? true : false"
      class="mb-1"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        {{ msjVal }}
      </div>
    </b-alert>

    <b-alert
      v-height-fade.appear
      variant="danger"
      :show="msjVal.length === 0 && dataHL.estadoPersonal === 'R' ? true : false"
      class="mb-1"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        El postulante registra requisitoria
      </div>
    </b-alert>

    <b-alert
      v-height-fade.appear
      variant="info"
      :show="msjVal.length === 0 && dataHL.length === 0 ? true : false"
      class="mb-1"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        No se encontraron antecedentes laborales del postulante
      </div>
    </b-alert>

    <b-tabs
      v-if="dataReady"
      pills
    >
      <b-tab active>
        <template #title>
          <feather-icon
            icon="InfoIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Postulación</span>
        </template>
        <b-media class="mb-0">
          <template #aside>
            <b-avatar
              v-if="dataReady && dataUser.foto === ''"
              ref="previewEl"
              :src="require('@/assets/images/avatars/avatar_default.png')"
              size="132px"
              rounded
            />
            <b-avatar
              v-else
              ref="previewEl"
              :src="`data:image/jpeg;base64,${dataUser.foto}`"
              size="132px"
              rounded
            />
          </template>

          <b-form-group
            label="Nombres"
            label-for="nombres"
          >
            <b-form-input
              id="nombres"
              v-model="dataUser.nombres"
            />
          </b-form-group>

          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Apellido Paterno"
                label-for="apellido_paterno"
              >
                <b-form-input
                  id="apellido_paterno"
                  v-model="dataUser.apellidoPaterno"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Apellido Materno"
                label-for="apellido_materno"
              >
                <b-form-input
                  id="apellido_materno"
                  v-model="dataUser.apellidoMaterno"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-media>

        <b-row>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Talla Zapato"
              label-for="tallaZapato"
            >
              <b-form-input
                id="tallaZapato"
                v-model="dataUser.tallaZapato"
                type="number"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="9"
          >
            <b-form-group
              label="Observaciones"
              label-for="observaciones"
            >
              <b-form-input
                id="observaciones"
                v-model="dataUser.observaciones"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab
        :disabled="Object.keys(dataHL).length === 0 ? true : false"
      >
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Historial Laboral</span>
        </template>
        <b-row>
          <b-col md="12">
            <h6 class="mb-2">
              DATOS GENERALES
            </h6>
          </b-col>
        </b-row>
        <b-media class="mb-0">
          <template #aside>
            <b-avatar
              v-if="Object.keys(dataHL).length > 0 && dataHL.foto.length > 0 ? true : false"
              ref="previewEl"
              :src="`data:image/jpeg;base64,${dataHL.foto}`"
              size="132px"
              rounded
            />
            <b-avatar
              v-else
              ref="previewEl"
              :src="require('@/assets/images/avatars/avatar_default.png')"
              size="132px"
              rounded
            />
          </template>

          <b-form-group
            label="Nombres"
          >
            <b-form-input
              v-model="dataHL.nombres"
              size="sm"
              readonly
            />
          </b-form-group>

          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Apellido Paterno"
              >
                <b-form-input
                  v-model="dataHL.apellidoPaterno"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Apellido Materno"
              >
                <b-form-input
                  v-model="dataHL.apellidoMaterno"
                  size="sm"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-media>
        <b-row>
          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Fecha Nacimiento"
            >
              <b-form-input
                v-model="dataHL.fechaNacimiento"
                size="sm"
                readonly
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Sexo"
            >
              <b-form-input
                v-model="dataHL.sexo"
                :formatter="getSexo"
                size="sm"
                readonly
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="3"
          >
            <b-form-group
              label="Grupo Sangre"
            >
              <b-form-input
                v-model="dataHL.grupoSangreId"
                size="sm"
                readonly
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="Object.keys(dataHL).length > 0 && dataHL.foto.length > 0 ? true : false"
            cols="12"
            md="3"
          >
            <b-form-group
              label="Estado Civil"
            >
              <b-form-input
                v-model="dataHL.estadoCivil.descripcion"
                size="sm"
                readonly
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <h6 class="mb-2">
              ANTECEDENTES LABORALES
            </h6>
          </b-col>

          <b-table
            class="position-relative"
            :items="itemsA"
            responsive
            :fields="fieldsA"
            primary-key="id"
            show-empty
            empty-text="No se encontraron registros"
          >
            <template #cell(fecha)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ getDateFmt(data.item.fecha) }}</small>
              </b-media>
            </template>

            <template #cell(descripcion)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ data.item.descripcion }}</small>
              </b-media>
            </template>

            <template #cell(area)="data">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ data.item.area.descripcion }}
                </b-link>
                <small class="text-muted">{{ data.item.area.empresa.razonSocial }}</small>
              </b-media>
            </template>

            <template #cell(sede)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ data.item.sede.nombre }}</small>
              </b-media>
            </template>
          </b-table>
        </b-row>
        <b-row>
          <b-col md="12">
            <h6 class="mb-2">
              BAJAS LABORALES
            </h6>
          </b-col>

          <b-table
            class="position-relative"
            :items="itemsB"
            responsive
            :fields="fieldsB"
            primary-key="id"
            show-empty
            empty-text="No se encontraron registros"
          >
            <template #cell(fecha)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ getDateFmt(data.item.fecha) }}</small>
              </b-media>
            </template>

            <template #cell(motivo)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ data.item.motivo }}</small>
              </b-media>
            </template>

            <template #cell(area)="data">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ data.item.area.descripcion }}
                </b-link>
                <small class="text-muted">{{ data.item.area.empresa.razonSocial }}</small>
              </b-media>
            </template>

            <template #cell(sede)="data">
              <b-media vertical-align="center">
                <small class="text-muted">{{ data.item.sede.nombre }}</small>
              </b-media>
            </template>
          </b-table>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-form>
</template>

<script>
import store from '@/store'
import {
  BAlert, BAvatar, BButton, BRow, BCol, BForm, BFormGroup, BFormInput, BInputGroup, BInputGroupPrepend, BMedia, BLink, BTab, BTable, BTabs, BSpinner,
} from 'bootstrap-vue'
import moment from 'moment'
// import { showError } from '@/helpers'
import { heightFade } from '@core/directives/animations'
import vSelect from 'vue-select'

export default {
  components: {
    BAlert,
    BAvatar,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BMedia,
    BLink,
    BTab,
    BTable,
    BTabs,
    BSpinner,
    vSelect,
  },
  directives: {
    'height-fade': heightFade,
  },
  emits: ['update:is-busy-ficha', 'update:modal-show'],
  props: {
    activeFichaId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dataReady: false,
      formData: {},
      dataDocumentos: [],
      tipoDocSel: null,
      searchNroDoc: '',
      isBusy: false,
      dataUser: {},
      dataReniec: {},
      dataHL: {},
      msjVal: '',
      itemsA: [],
      fieldsA: [
        { key: 'idPersonalAntecedente', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
        { key: 'fecha', sortable: true },
        { key: 'descripcion', sortable: true },
        { key: 'area', sortable: false },
        { key: 'sede', sortable: false },
      ],
      itemsB: [],
      fieldsB: [
        { key: 'idPersonalBaja', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
        { key: 'fecha', sortable: true },
        { key: 'motivo', sortable: true },
        { key: 'area', sortable: false },
        { key: 'sede', sortable: false },
      ],
    }
  },
  async mounted() {
    await this.getDocumentos()
  },
  methods: {
    getDateFmt(fecha) {
      return moment(String(fecha)).format('DD/MM/YYYY')
    },
    async saveForm() {
      // Validar datos antes
      if (this.tipoDocSel === null) {
        // this.showError({ response: { data: { message: 'Debe seleccionar un tipo de documento' } } })
        this.$emit('update:is-busy-ficha', false)
        return
      }

      if (this.tipoDocSel.idDocumentoIdentidad !== 0 && (this.searchNroDoc.length !== this.tipoDocSel.digitos)) {
        // this.showError({ response: { data: { message: 'Debe ingresar un número de tipo de documento válido' } } })
        this.$emit('update:is-busy-ficha', false)
        return
      }

      if (this.dataHL.estadoPersonal === 'R') {
        // this.showError({ response: { data: { message: 'No podemos continuar, el postulante registra requisitoria' } } })
        this.$emit('update:is-busy-ficha', false)
        return
      }

      if (Object.keys(this.dataHL).length > 0 && this.dataHL.bajas.length > 0) {
        const ultBaja = this.dataHL.bajas[0]
        const hoy = moment(moment(), 'DD-MM-YYYY')
        if (ultBaja.fecha.length > 0) {
          const diasDif = hoy.diff(moment(moment(ultBaja.fecha).format('DD-MM-YYYY'), 'DD-MM-YYYY'), 'days')
          if (diasDif <= 30) {
            // this.showError({ response: { data: { message: `No podemos continuar, el reclutado tiene ${diasDif} día(s) de baja, existe una resitricción de mínimo un mes para volver a ingresar a la empresa.` } } })
            this.$emit('update:is-busy-ficha', false)
            return
          }
        }
      }

      const service = 'reclutamiento/DETALLE_CREATE'
      this.formData.nombre = this.dataUser.nombres
      this.formData.apellidoPaterno = this.dataUser.apellidoPaterno
      this.formData.apellidoMaterno = this.dataUser.apellidoMaterno
      this.formData.dni = this.searchNroDoc
      this.formData.estado = 0
      this.formData.fichaReclutamiento = {
        idFichaReclutamiento: this.activeFichaId,
      }
      this.formData.tallaZapato = this.dataUser.tallaZapato
      this.formData.observaciones = this.dataUser.observaciones
      if (this.dataUser.foto.length > 0) {
        this.formData.foto = this.dataUser.foto
      }

      await store.dispatch(service, this.formData)
        .then(response => {
          this.$emit('refetch-data', response)
          this.$emit('update:modal-show', false)
        })
        .catch(error => {
          this.$emit('error-data', error)
        })
      this.$emit('update:is-busy-ficha', false)
    },
    async consultaHistorialLaboral() {
      this.isBusy = true
      this.msjVal = ''
      this.dataHL = {}
      // Validaciones
      if (this.tipoDocSel === null) {
        this.isBusy = false
        this.msjVal = 'Debe seleccionar un tipo de documento'
        return
      }

      if (this.tipoDocSel.idDocumentoIdentidad !== 0 && (this.searchNroDoc.length !== this.tipoDocSel.digitos)) {
        this.isBusy = false
        this.msjVal = 'Debe ingresar un número de tipo de documento válido'
        return
      }

      await store
        .dispatch('personal/PERSONAL_FIND_BY_DOC', {
          idDocumentoIdentidad: this.tipoDocSel.idDocumentoIdentidad,
          documentoIdentidadNumero: this.searchNroDoc,
        })
        .then(response => {
          if (response) {
            this.dataHL = response
            this.dataHL.fechaNacimiento = this.getDateFmt(this.dataHL.fechaNacimiento)
          }
        })
        .catch(error => {
          console.log(error)
          // this.showError(error)
        })
      this.isBusy = false
    },
    async consultaReniec() {
      this.isBusy = true
      this.msjVal = ''
      this.dataReniec = {}
      // Validaciones
      if (this.tipoDocSel === null) {
        this.isBusy = false
        this.msjVal = 'Debe seleccionar un tipo de documento'
        return
      }

      if (this.tipoDocSel.idDocumentoIdentidad !== 0 && (this.searchNroDoc.length !== this.tipoDocSel.digitos)) {
        this.isBusy = false
        this.msjVal = 'Debe ingresar un número de tipo de documento válido'
        return
      }
      await store
        .dispatch('helpers/RENIEC_FIND_CIUDADANO', {
          dni: this.searchNroDoc,
        })
        .then(response => {
          if (response !== undefined) {
            this.dataReniec = response.datosPersona
            // this.dataReniec.apellidoPaterno = utf8.decode(this.dataReniec.apellidoPaterno)
          }
        })
        .catch(error => {
          console.log(error)
          // this.showError(error)
        })
      this.isBusy = false
    },
    async searchPostulant() {
      this.dataReady = false
      await this.consultaReniec()
      await this.consultaHistorialLaboral()

      this.dataUser.personalId = 0
      if (this.dataReniec !== null) {
        this.dataUser.foto = this.dataReniec.foto
        this.dataUser.nombres = this.dataReniec.prenombres
        this.dataUser.apellidoPaterno = this.dataReniec.apPrimer
        this.dataUser.apellidoMaterno = this.dataReniec.apSegundo
      }
      if (Object.keys(this.dataHL).length > 0) {
        this.dataUser.personalId = this.dataHL.idPersonal
        this.itemsA = this.dataHL.antecedentes
        this.itemsB = this.dataHL.bajas
      }
      this.dataReady = true
    },
    getSexo(abrev) {
      let desc
      switch (abrev) {
        case 'M':
          desc = 'MASCULINO'
          break
        case 'F':
          desc = 'FEMENINO'
          break
        default:
          desc = 'NO REGISTRA'
          break
      }
      return desc
    },
    async getDocumentos() {
      await store
        .dispatch('catalogos/DOCUMENTO_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
        })
        .then(response => {
          if (response !== undefined) {
            this.dataDocumentos = response.items
            this.tipoDocSel = this.dataDocumentos.find(id => id.idDocumentoIdentidad === 1)
          }
        })
        .catch(error => {
          console.log(error)
          // this.showError(error)
        })
    },
    // showError,
  },
}
</script>

<style lang="scss">
#vs2__combobox {
  border-radius: 0rem;
  padding: 0.59px 0 4.5px 0;
}
#search-reclutado {
  padding-left: 10px;
}
</style>
